var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
var symboll = window.shop_symbol;
if (document.querySelector('[name="country_code"]') != null) {
  symboll = document.querySelector('[name="country_code"]').getAttribute("symbol");
}
if (document.querySelector(".template--cart")) {
  var currentItemCount = Array.from(document.querySelector(".template--cart").querySelectorAll('[name="updates[]"]')).reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);
}
Shopify.money_format = symboll + "{{amount}}";
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100.0).toFixed(precision);
    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";
    return dollars + cents;
  }
  switch (formatString.match(placeholderRegex)[1]) {
  case "amount":
    value = formatWithDelimiters(cents, 2);
    break;
  case "amount_no_decimals":
    value = formatWithDelimiters(cents, 0);
    break;
  case "amount_with_comma_separator":
    value = formatWithDelimiters(cents, 2, ".", ",");
    break;
  case "amount_no_decimals_with_comma_separator":
    value = formatWithDelimiters(cents, 0, ".", ",");
    break;
  }
  return formatString.replace(placeholderRegex, value);
};
var languageRoot = Shopify.routes.root;
var languageRootRemovedLastSlash = languageRoot.slice(0, languageRoot.length - 1);
var isOpen = false;
var timer;
var lehaAddPending = false;
function cartMessage(name) {
  return document.querySelector('leha-cart-confirmation')?.dataset[name] || 'تعذرت إضافة المنتج. يرجى المحاولة مجددًا.';
}
function submitCartAddition(button, event) {
  event.preventDefault(); event.stopPropagation();
  var form = button.closest('form');
  if (!form || button.disabled || lehaAddPending) return;
  closeCart();
  addProductToCart(button.getAttribute('product_id'),button.getAttribute('metaf'),form.querySelector('[name="id"]')?.value,new FormData(form),button);
}
document.addEventListener('click',function (event) {
  var button = event.target.closest('.add-to-cart-btn, .product-form__submit');
  if (button) submitCartAddition(button,event);
});
document.addEventListener('submit',function (event) {
  var button = event.target.querySelector('.add-to-cart-btn, .product-form__submit');
  if (button) submitCartAddition(button,event);
});
async function addProductToCart(formID, metafields, productID, target, clickedAtcButton) {
  var form = clickedAtcButton.closest('form');
  var root = clickedAtcButton.closest('[data-leha-product]');
  if (lehaAddPending || !form || clickedAtcButton.disabled) return false;
  var quantity = Number(target.get('quantity') || 1), variantId = String(target.get('id') || '');
  if (!variantId || !Number.isSafeInteger(quantity) || quantity < 1) {
    handleErrorMessage(cartMessage('confirmFailed'),clickedAtcButton); return false;
  }
  var summary = root && window.LehaCommercialPricing?.purchaseSummary(root);
  if (root && !summary) { handleErrorMessage(cartMessage('confirmFailed'),clickedAtcButton); return false; }
  var chosen = root?.querySelector('[data-leha-package-option]:checked')?.closest('label')?.querySelector('[data-leha-package-label]');
  var focused = document.activeElement;
  var context = {variantId,quantity,summary,label:chosen?.textContent.trim() || '',opener:root?.contains(focused) ? focused : clickedAtcButton};
  lehaAddPending = true; form.dataset.lehaCartPending = 'true'; clickedAtcButton.setAttribute('aria-busy','true');
  handleErrorMessage(false,clickedAtcButton);
  var confirmed = false;
  try {
    var recipient = form.querySelector('[name="properties[__shopify_send_gift_card_to_recipient]"]');
    if (recipient?.checked && !form.querySelector('[name="properties[Recipient email]"]')?.value) {
      handleErrorMessage(cartMessage('confirmFailed'),clickedAtcButton); return false;
    }
    var request = await fetch(window.routes.cart_add_url + '.js',{body:target,headers:{'X-Requested-With':'xmlhttprequest'},method:'POST',credentials:'same-origin'});
    var reply = await request.json();
    if (request.ok === false || reply.status || reply.errors) { handleErrorMessage(cartMessage('confirmFailed'),clickedAtcButton); return false; }
    if (!reply.id && !reply.variant_id && !reply.items?.length) throw Error('add_response_missing');
    confirmed = true;
    var wrapper = clickedAtcButton.closest('.quick-view_grid, .product__detail');
    var wrapping = !root && wrapper?.querySelector('.product__wrapping');
    if (wrapping && wrapper.querySelector('.add_gift_wrapping')?.checked) {
      var gift = {id:wrapping.dataset.giftId,quantity:1,properties:{_gift_wrapping_message:wrapping.querySelector('textarea')?.value || '',_gift_wrapping_product:wrapping.dataset.giftProduct}};
      var giftRequest = await fetch(window.routes.cart_add_url + '.js',{body:JSON.stringify({items:[gift]}),credentials:'same-origin',headers:{'Content-Type':'application/json','X-Requested-With':'xmlhttprequest'},method:'POST'});
      if (!giftRequest.ok) throw Error('wrapping_failed');
    }
    if (form.isConnected) addToCartOk('',reply,context); else fetchCart();
    return true;
  } catch (error) {
    handleErrorMessage(cartMessage(confirmed ? 'confirmCartError' : 'confirmUncertain'),clickedAtcButton); return false;
  } finally {
    lehaAddPending = false; delete form.dataset.lehaCartPending; clickedAtcButton.removeAttribute('aria-busy'); stopLoading();
  }
}
function handleErrorMessage(errorMessage = false, button) {
  var scope = button?.closest('.product__detail, .quick-view_grid') || document;
  var wrappers = scope.querySelectorAll('.product-form__error-message-wrapper');
  wrappers.forEach(function (wrapper) {
    wrapper.toggleAttribute('hidden',!errorMessage);
    var text = wrapper.querySelector('.product-form__error-message'); if (text) text.textContent = errorMessage || '';
  });
  if (!errorMessage) document.querySelector('[data-confirm-error]')?.setAttribute('hidden','');
  if (errorMessage && !wrappers.length) window.LehaCartConfirmation?.error(errorMessage);
}

function testQty(itemID, value) {
  changeItem(itemID, value);
}

function fetchCart(line) {
  return fetch(window.routes.cart_url + ".js")
    .then((response) => response.json())
    .then((response) => {
      var cart = response;
      onCartUpdate(cart);
      renderCart(cart, line);
    }).catch(function () { stopLoading(); });
}

var lehaCartChanges = Promise.resolve();
var lehaCheckoutPending = false;
var lehaCartKeyAliases = new Map();
function lehaCartRequest(url, options) {
  var controller=new AbortController(), timer=setTimeout(function(){controller.abort();},10000);
  return fetch(url,{...options,signal:controller.signal}).finally(function(){clearTimeout(timer);});
}
function lehaPropertyMap(properties) {
  if (properties == null) return {};
  if (Array.isArray(properties)) {
    if (properties.some(function (pair) { return !Array.isArray(pair) || pair.length !== 2 || typeof pair[0] !== 'string'; })) throw Error('verification');
    return Object.fromEntries(properties);
  }
  if (typeof properties !== 'object') throw Error('verification');
  return {...properties};
}
function lehaPropertyIdentity(properties) {
  var values=lehaPropertyMap(properties);
  // Shopify may omit the optional empty offer reference; a nonempty reference
  // and every other property remain part of the identity.
  if (values._leha_offer_handle === '') delete values._leha_offer_handle;
  return JSON.stringify(Object.entries(values).sort(function(a,b){return a[0].localeCompare(b[0]);}));
}

function changeItem(line, quantity, callback, properties, validateBefore) {
  quantity = Number(quantity);
  var key = String(line);
  if (!Number.isSafeInteger(quantity) || quantity < 0) return Promise.resolve(false);
  var perform = async function () {
    startLoading();
    window.LehaCartPage?.busy(true);
    var container = document.querySelector('.cart-page'), sectionId = container?.dataset.lehaCartSection;
    try {
      var live = await lehaCartRequest(window.routes.cart_url+'.js',{credentials:'same-origin',cache:'no-store'});
      var before = await live.json();
      if (!live.ok || !Array.isArray(before.items)) throw Error('update_failed');
      if (validateBefore) validateBefore(before);
      key = lehaCartKeyAliases.has(key) ? lehaCartKeyAliases.get(key) : key;
      var previous = before.items.find(item => item.key === key);
      if (!previous) throw Error('changed');
      var payload = {id:key,quantity};
      if (properties) payload.properties = {...lehaPropertyMap(previous.properties),...lehaPropertyMap(properties)};
      if (sectionId) { payload.sections = [sectionId]; payload.sections_url = window.location.pathname + window.location.search; }
      var response = await lehaCartRequest(window.routes.cart_change_url + '.js',{method:'POST',headers:{Accept:'application/json','Content-Type':'application/json'},body:JSON.stringify(payload),credentials:'same-origin'});
      var cart = await response.json();
      if (!response.ok || cart.status || cart.errors || !Array.isArray(cart.items)) throw Error(response.status===422?'inventory':'update_failed');
      var matches=cart.items.filter(item => String(item.variant_id)===String(previous.variant_id) && lehaPropertyIdentity(item.properties)===lehaPropertyIdentity(payload.properties||previous.properties) && String(item.selling_plan_allocation?.selling_plan?.id||'')===String(previous.selling_plan_allocation?.selling_plan?.id||''));
      var nextKey=quantity===0?null:matches.length===1?matches[0].key:key;
      for (var [alias,value] of lehaCartKeyAliases) if (value===key) lehaCartKeyAliases.set(alias,nextKey);
      lehaCartKeyAliases.set(key,nextKey);
      if (container && sectionId) {
        var html=cart.sections?.[sectionId];
        var fresh=html && new DOMParser().parseFromString(html,'text/html').querySelector('.cart-page');
        if (fresh && window.LehaCartPage) window.LehaCartPage.replace(fresh);
        else if (window.LehaCartPage) await window.LehaCartPage.refresh(false);
        else if (fresh) container.replaceWith(fresh);
        else throw Error('update_failed');
      }
      renderCart(cart);
      if (typeof callback === 'function') callback(cart); else onCartUpdate(cart);
      return true;
    } catch (error) {
      try { if (window.LehaCartPage) { await window.LehaCartPage.refresh(false); renderCart(await window.LehaCartPage.getCart()); } } catch (_) {}
      if (window.LehaCartPage) window.LehaCartPage.error(error.message);
      else { var message=document.querySelector('#cart-errors'); if(message) message.textContent=cartMessage('confirmCartError'); }
      return false;
    } finally { stopLoading(); window.LehaCartPage?.busy(lehaCheckoutPending); }
  };
  lehaCartChanges = lehaCartChanges.then(perform,perform);
  return lehaCartChanges;
}
function removeItem(itemID) { return changeItem(itemID,0); }

function onCartUpdate(cart) {
  // Do nothing, logic handled before render
}

function addToCartOk(target, product, context) {
  openCart(product,context);
  fetchCart();
}

function addToCartFail() {
  console.warn("Error adding to cart: -------------------");
}

function renderCart(cart, line) {  
  if (document.querySelector(".header-cart-count")) {
    if (cart.item_count > 0) {
      document.querySelector(".header-cart-count").closest(".cart-count-bubble").style.display = "flex";
    } else {
      document.querySelector(".header-cart-count").closest(".cart-count-bubble").style.display = "none";
    }
    var get_cart_count = document.querySelectorAll(".header-cart-count");
    for (var i = 0; i < get_cart_count.length; i++) {
      get_cart_count[i].innerText = cart.item_count;
    }
  }

  stopLoading();
}

document.addEventListener("DOMContentLoaded", function () {
  fetchCart();
});

function closeCart() { window.LehaCartConfirmation?.close(); }
function openCart(product,context) { window.LehaCartConfirmation?.open(product,context); }

function isCartOpen() {
  return isOpen;
}

function startLoading() {
  document.querySelector(".cartLoader")?.classList.remove("is-hidden");
}

function stopLoading() {
  document.querySelector(".cartLoader")?.classList.add("is-hidden");
}

function isNotLoading() {
  return document.querySelector(".cartLoader")?.classList.contains("is-hidden");
}

document.addEventListener("DOMContentLoaded", function () {
  document.addEventListener("change", (event) => {
    const changedColorRadio = event.target.closest(
      '[data_options="color"] input[type="radio"]'
    );
    if (!changedColorRadio) return; //do nothing
    if (changedColorRadio.value != undefined) {
      if (!!changedColorRadio.closest(".product-form__input")) {
        let productFormInput = changedColorRadio.closest(".product-form__input");
        if (!!productFormInput.querySelector(".form__label span")) {
          productFormInput.querySelector(".form__label span").innerText = changedColorRadio.value;
        }
      }
    }
  });
  var selectors = {
    termsCheckbox: ".cart__terms-checkbox",
    requiresTerms: false,
  };
  if (!!document.querySelector(".js-cart-terms-checkboxes")) {
    var termsCheckboxes = document.querySelectorAll(
      ".js-cart-terms-checkboxes"
    );
    var requiresTerms = true;
    termsCheckboxes.forEach(function (termsCheckbox) {
      termsCheckbox.addEventListener("change", function (event) {
        var checkedStatus = event.target.checked;
        termsCheckboxes.forEach(function (termsCheckbox) {
          termsCheckbox.checked = checkedStatus;
        });
      });
    });
  } else {
    var requiresTerms = false;
  }
  document.addEventListener('submit',function (event) {
    if (event.target.id !== 'cart' || event.submitter?.name !== 'checkout') return;
    if (window.LehaCartPage) window.LehaCartPage.checkout(event);
    else { event.preventDefault(); var error=document.getElementById('cart-errors'); if(error){error.hidden=false;error.textContent='تعذّر الانتقال إلى إتمام الطلب. حاول مرة أخرى.';} }
  });
});


document.querySelectorAll(".collection-product-item .grid-variant-input").forEach((swatch) => {
  swatch.addEventListener("click", (e) => {
    setTimeout(function () {
      const value = swatch
        .closest(".grid-options")
        .querySelector("select")
        .getAttribute("value");
      const variant = swatch
        .closest(".grid-options")
        .querySelector(`select option[value="${value}"]`);
      if (!variant) return;
      const unitPrice = variant.getAttribute("data-unit-price");

      // update unit price
      if (!unitPrice) {
        swatch
          .closest(".card-details__wrapper")
          .querySelector(".unit-price").style.visibility = "hidden";
      } else {
        swatch
          .closest(".card-details__wrapper")
          .querySelector(".unit-price").style.visibility = "visible";
        swatch
          .closest(".card-details__wrapper")
          .querySelector(".unit-price > dd > span:first-child").innerHTML =
          unitPrice;
      }
    }, 200);
  });
});

